<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/services/banner_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">My Profile</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						Edit information
					</div>
					<div class="right">
						<el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="160px" class="demo-ruleForm">
							<el-form-item label="First Name" prop="firstName">
								<el-input v-model="ruleForm.firstName" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Last Name" prop="lastName">
								<el-input v-model="ruleForm.lastName" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Organization Name" prop="organizationName">
								<el-input v-model="ruleForm.organizationName" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Street Address" prop="streetAdress">
								<el-input v-model="ruleForm.streetAdress" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="City" prop="city">
								<el-input v-model="ruleForm.city" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="State" prop="state">
								<el-input v-model="ruleForm.state" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Country" prop="country">
								<el-input v-model="ruleForm.country" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Zip Code" prop="zipCode">
								<el-input v-model="ruleForm.zipCode" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Email" prop="" style="position: relative;margin-bottom: 0;">
								<el-input disabled v-model="ruleForm.email" placeholder="Enter"></el-input>
								<div style="padding-top: 5px;text-align: right;">
									<span style="color: #006BB3;font-size: 16px;right: -36px;cursor: pointer;text-decoration: underline;font-style: italic;" @click="goEditEmail">Edit</span>
								</div>
							</el-form-item>
							<el-form-item label="Phone" prop="">
								<el-input v-model="ruleForm.phone" placeholder="Enter"></el-input>
							</el-form-item>
							<el-form-item label="Customer Number" prop="">
								<el-input v-model="ruleForm.customerNumber" placeholder="Enter"></el-input>
							</el-form-item>
						</el-form>
						<div class="btn_box">
							<van-button color="#E37542" class="btn_el" @click="saveEdit('ruleForm')">Save</van-button>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { UPURL } from '@/util/util.js';
import { editInfo, userInfo } from '@/api/public.js';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isLoading: true,  //界面loading
			ruleForm: {
				firstName: '',
				lastName: '',
				organizationName: '',
				streetAdress: '',
				city: '',
				state: '',
				country: '',
				zipCode: '',
				email: localStorage.getItem('email'),
				phone: '',
				customerNumber: ''
			},
			rules: {
				firstName: [
					{ required: true, message: 'Please enter your First Name', trigger: 'blur' }
				],
				lastName: [
					{ required: true, message: 'Please enter your Last Name', trigger: 'blur' }
				],
				organizationName: [
					{ required: true, message: 'Please enter your Organization Name', trigger: 'blur' }
				],
				streetAdress: [
					{ required: true, message: 'Please enter your Street Address', trigger: 'blur' }
				],
				city: [
					{ required: true, message: 'Please enter your City', trigger: 'blur' }
				],
				state: [
					{ required: true, message: 'Please enter your State', trigger: 'blur' }
				],
				country: [
					{ required: true, message: 'Please enter your Country', trigger: 'blur' }
				],
				zipCode: [
					{ required: true, message: 'Please enter your Zip Code', trigger: 'blur' }
				],
				email: [
					{ required: true, message: 'Please enter your Email', trigger: 'blur' }
				],
			},
			userToken: localStorage.getItem('userToken')
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.userToken) {
			userInfo().then(res => {
				that.ruleForm = {
					firstName: res.data.first_name,
					lastName: res.data.last_name,
					organizationName: res.data.organization_name,
					streetAdress: res.data.street_address,
					city: res.data.city,
					state: res.data.state,
					country: res.data.country,
					zipCode: res.data.zip_code,
					phone: res.data.mobile,
					email: res.data.email,
					customerNumber: res.data.customer_number
				},
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
		}
	},
	methods: {
		//点击确定
		saveEdit(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
					editInfo({
						first_name: that.ruleForm.firstName,
						last_name: that.ruleForm.lastName,
						organization_name: that.ruleForm.organizationName,
						street_address: that.ruleForm.streetAdress,
						city: that.ruleForm.city,
						state: that.ruleForm.state,
						zip_code: that.ruleForm.zipCode,
						country: that.ruleForm.country,
						mobile: that.ruleForm.phone,
						customer_number: that.ruleForm.customerNumber
					}).then(res => {
						that.$toast.clear();
						localStorage.setItem('firstName', that.ruleForm.firstName);
						that.$toast('Modified successfully');
						setTimeout(() => {
							window.location.reload();
						}, 1000);
					});
				}
			})
		},
		goEditEmail() {
			this.$router.push('/edit-email');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	.block_1{
		width: 100%;
		padding: 50px 20px;
		.block_1_main{
			
			margin: 0 auto;
			// display: flex;
			.right{
				// flex: 1.2;
				.btn_box{
					padding-top: 20px;
					text-align: center;
					.btn_el{
						padding: 8px 30px 5px 30px;
						font-size: 20px;
						border-radius: 6px;
					}
				}
			}
			.left{
				// flex: 1;
				padding-bottom: 20px;
				text-align: center;
				font-size: 40px;
				color: #006BB3;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
>>> .el-form-item{
	margin-bottom: 15px;
}
>>> .el-form--label-top .el-form-item__label{
	padding-bottom: 0;
	color: #006BB3;
	font-size: 16px;
}
>>> .el-input__inner{
	height: 42px;
	font-size: 18px;
	border: 1px solid #CCCCCC;
}
</style>